type LogLevel = 'log' | 'warn' | 'error';

const buildPrefix = (scope: string, message: string) => `[livechat][${scope}] ${message}`;

const writeLog = (level: LogLevel, scope: string, message: string, ...args: any[]) => {
	const logger = console[level] || console.log;
	logger(buildPrefix(scope, message), ...args);
};

const createLogger = (scope: string) => ({
	log: (message: string, ...args: any[]) => writeLog('log', scope, message, ...args),
	warn: (message: string, ...args: any[]) => writeLog('warn', scope, message, ...args),
	error: (message: string, ...args: any[]) => writeLog('error', scope, message, ...args),
});

export default createLogger;
